export default __webpack_public_path__ + "static/media/Dexterity_2.9a3b1378.png";